import { Component, Input } from '@angular/core';

@Component({
  selector: 'apc-code-value-form',
  templateUrl: './code-value-form.component.html',
  styleUrls: ['./code-value-form.component.scss'],
})
export class CodeValueFormComponent {
  @Input() public form: any;
  @Input() public showManager: boolean;
  @Input() public section: string;
  @Input() public subsection: string;
  @Input() public type: string;
  @Input() public managers;

  findManagerRenderValue() {
    let findObject = this.managers.find(el => el.identifier == this.form.value.managerIdentifier);
    return findObject ? findObject.fullName : '';
  }
}
